import {Injectable, NgModule} from '@angular/core';
import {Action, Store, StoreModule} from '@ngrx/store';
import {SubscriptionLike} from 'rxjs';
import {reducers} from '../app.reducers';
import {EffectsModule} from '@ngrx/effects';
import {PubmaticEffects} from '../segment/info/shared-targets-list/account-pubmatic/pubmatic-effects';
import {AppGlobalEffects} from './app-global-effects';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {SegmentsEffects} from '../segment/segments.effects';
import {TargetEffects} from '../target/target.effects';
import {GlobalEffects} from './global.effects';
import {FiltersConfigEffects} from '../filters-config/filters-config.effects';

/**
 * This class wraps the old AppStore to be able to migrate smoother to the new one.
 *
 * Step 1 is to completely use this wrapper!
 */
@Injectable({providedIn: 'root'})
export class AppStore {

  private currentState: any;

  constructor(private store: Store<any>) {
    this.store.subscribe((state) => this.currentState = state);
  }

  /**
   * Get current state
   */
  getState(): any {
    return this.currentState;
  }

  /**
   * subscribe to a callback with the state
   */
  subscribe(subscriber: any): SubscriptionLike {
    return this.store.subscribe(subscriber);
  }

  /**
   * Dispatch an action
   */
  dispatch(action: Action | any): void {
    this.store.dispatch(action);
  }

}

// New in 9: https://v9.ngrx.io/guide/store/configuration/runtime-checks
export const NGRX_RUNTIME_CHECKS = {
  strictStateSerializability: false,
  strictActionSerializability: false,
  strictStateImmutability: false,
  strictActionImmutability: false,
  strictActionWithinNgZone: false,
  strictActionTypeUniqueness: true,
};

@NgModule({
  providers: [],
  imports: [
    // @ts-ignore
    StoreModule.forRoot(reducers, {
      runtimeChecks: NGRX_RUNTIME_CHECKS,
    }),
    EffectsModule.forRoot([PubmaticEffects, AppGlobalEffects, SegmentsEffects, TargetEffects, GlobalEffects, FiltersConfigEffects]),
    StoreDevtoolsModule.instrument()
  ],
})
export class DmpStoreModule {
}
